import { useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { Flex, Button } from "antd";

import { FILTER_KEYS, SORTER_KEYS } from "constants/table";
import AdvancedSearchButton from "components/Common/AdvancedSearchButton";
import AdvancedSearchModal from "components/ItemList/AdvancedSearchModal";
import Pagination from "components/Common/Pagination";
import SearchBar from "components/Common/SearchBar";

// ##### Functions #####

const getFilterCount = (filters) => {
  return Object.entries(filters).reduce((acc, [key, val]) => {
    let filterCount = 0;

    if (key === FILTER_KEYS.SORTERS) {
      filterCount = Array.isArray(val)
        ? val.filter(
            (v) => !!v?.[SORTER_KEYS.SORT_BY] && !!v?.[SORTER_KEYS.SORT_ORDER]
          ).length
        : 0;
    } else if (
      ![FILTER_KEYS.PAGE, FILTER_KEYS.PAGE_SIZE, "products"].includes(key)
    ) {
      const isFiltered =
        val !== null &&
        val !== undefined &&
        val !== "" &&
        (!Array.isArray(val) || val.length > 0);
      filterCount = isFiltered ? 1 : 0;
    }

    return acc + filterCount;
  }, 0);
};

const ItemTableHeader = ({
  filters,
  tableDataTotalCount,
  loading,
  onFiltersChange,
  fetchUnitListForExport,
}) => {
  const [showAdvancedSearchModal, setShowAdvancedSearchModal] = useState(false);
  const [searchBarKey, setSearchBarKey] = useState(1);
  const [prevFilters, setPrevFilters] = useState(filters);

  if (JSON.stringify(prevFilters) !== JSON.stringify(filters)) {
    setPrevFilters(filters);
    setSearchBarKey(searchBarKey + 1);
  }

  const filterCount = getFilterCount(filters);

  return (
    <>
      <Flex justify="space-between" gap="0.5rem 0" wrap="wrap">
        <Flex gap="small" wrap="wrap">
          <SearchBar
            key={searchBarKey}
            defaultValue={filters[FILTER_KEYS.SEARCH]}
            onSearch={(val) =>
              onFiltersChange({
                [FILTER_KEYS.SEARCH]: val,
              })
            }
            loading={loading}
            enableOnChange={true}
          />
          <AdvancedSearchButton
            filterCount={filterCount}
            loading={loading}
            onClick={() => setShowAdvancedSearchModal(true)}
          />
          <Button
            disabled={loading}
            onClick={fetchUnitListForExport}
            icon={<DownloadOutlined />}
            type="text"
          />
        </Flex>

        <Pagination
          currentPage={filters[FILTER_KEYS.PAGE]}
          currentPageSize={filters[FILTER_KEYS.PAGE_SIZE]}
          totalCount={tableDataTotalCount}
          loading={loading}
          onChange={(page, pageSize) => {
            onFiltersChange({
              [FILTER_KEYS.PAGE]: page,
              [FILTER_KEYS.PAGE_SIZE]: pageSize,
            });
          }}
        />
      </Flex>
      <AdvancedSearchModal
        showModal={showAdvancedSearchModal}
        filters={filters}
        onShowModalChange={setShowAdvancedSearchModal}
        onFiltersChange={onFiltersChange}
      />
    </>
  );
};

export default ItemTableHeader;
